import React, { useEffect, useLayoutEffect, useState, useContext, useRef } from 'react';
import axios from 'axios';
import gsap from 'gsap';

import { getFirstImage, slugify, labUrl, getSecondImage } from '../helpers/helperFunctions.js';
import SiteLoader from './SiteLoader.jsx';
import { AppContext } from '../context/AppContext.jsx';
import { useLanguage } from "../i18n/LanguageContext.jsx";
import i18n from "../i18n/i18n";
import ScrollTrigger from '../../gsap/ScrollTrigger.min.js';

gsap.registerPlugin(ScrollTrigger);


const HeroImage = ({ item, customHeight, article, tags, className }) => {
    const { language } = useLanguage();
    const { siteMap, loaderDuration } = useContext(AppContext);
    const [hasImage, setHasImage] = useState(false);
    const [title, setTitle] = useState(null);

    const heroImageRef = useRef(null);

    useEffect(() => {
        if (item && item.media && item.media.length > 0) {
            setHasImage(true);
        } else {
            setHasImage(false);
        }
        /*console.log('HeroImage item updated:', item);*/
    }, [item]);

    useEffect(() => {
        if (item && item.title && item.title.toLowerCase().includes("press")) {
            setTitle(item.title + " Kit");
        } else {
            setTitle(item.title);
        }
    }, [item, item.title]); 


    return (
        <>
            {article ? (
                <>
                    <div className={`hero hero-inside hero-art ${className}`} style={{ marginTop: "200px", marginBottom: hasImage ? "100px" : "0" }}>
                        <div className="container-xl position-relative z-1">
                            <div className="row position-relative mb-10">
                                <div className="col-lg-10 col-xl-9">
                                    {title && (
                                        <h1 className={`hero-title-article lh-1 display-4 fw-bold ${tags?.length > 0 ? "mb-4" : ""}`}>
                                            {title}
                                        </h1>
                                    )}
                                    {tags && tags.length > 0 && tags.map((tag, index) => (
                                        <span key={index} className="fs-5 me-2 mb-2">#{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {item && hasImage && (
                            <div className="container-xl hero hero-inside hero-container">
                                <div className="row position-relative">
                                    <div className="col-12">
                                        <img
                                            ref={heroImageRef}
                                            src={getSecondImage(item) || getFirstImage(item)}
                                            className="hero-image"
                                            alt="hero media"
                                            style={{ height: (customHeight || "550px") }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="hero hero-inside" style={{ marginTop: "200px", marginBottom: hasImage ? "100px" : "0" }}>
                        <div className="container-xl position-relative z-1">
                            <div className="row position-relative">
                                    <div className="col-12">
                                        {title && (
                                            <h1 className="hero-title">
                                                {title}
                                            </h1>
                                        )}
                                </div>
                            </div>
                        </div>

                        {item && hasImage && (
                            <div className="container-fluid hero hero-inside hero-container">
                                    <div className="row position-relative">
                                    <div className="col-12 px-0">
                                        <img
                                            ref={heroImageRef}
                                            src={getFirstImage(item) || "/content/img/default-hero-image-01.jpg"}
                                            className="hero-image"
                                            alt="hero media"
                                            style={{ height: (customHeight || "550px") }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div >
                </>
            )}
        </>
    );
};

export default HeroImage;
